import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const InformedSearchMethods = () => (
  <AIModuleSubtopic
    title="Informed Search Methods- Best First Search, A* Search"
    videos={[
      "https://www.youtube.com/embed/aS0JolWei14",
      "https://www.youtube.com/embed/PzEWHH2v3TE"
    ]}
    takeaways={[
      { text: "Understand how heuristic functions guide informed search algorithms." },
      { text: "Learn the differences and applications of Greedy Best-First Search and A* Search." }
    ]}
    questions={[
      {
        text: "Apply A* Search algorithm to find the shortest path from a to z using the following graph",
        image:"/ai_12.png"
      },
      {
        text: "Trace the operation of A' search applied to the problem of getting to Bucharest from Lugoj using the straight-line distance heuristic. Show the sequence of nodes that the algorithm will consider to reach the goal. Refer to the Hsld mentioned in the table below",
        image:"/ai_14.png"
      },
      {
        text: "Use the Greedy Best-First Search algorithm to solve the Romanian problem. The agent is on holiday in Romania and is currently located in the city of Arad. The agent has a flight from Bucharest tomorrow, so it can't be changed. Now you need to find the shortest path to Bucharest.",
        image:"/ai_14.png"
      },
      {
        text: "Consider the search graph depicted in Figure in which node “1” represents the source node and node “8” represents the goal node. The weight of the edge (i-j) represents the distance between node i to node j. The weights labeled on the top of node i represent the distance from node i to the goal node. Determine the optimal search path from the source node to the goal node using the A* algorithm. Prove that A* is optimal.",
        image:"/ai-15.png"
      },
      {
        text: "State the significance of using heuristic functions. Perform the A* search algorithm on the graph given below taking node ‘0’ as the starting node and giving the proof of optimality.",
        image:"/ai_16.png"
      },
      {
        text: "From the Following Figure. a)What path would the breadth-first graph search return for this search problem? S-G b)What path would uniform cost graph search return for this search problem? S-A-C-G c)What path would the depth-first graph search return for this search problem? S-A-B-D-G d)What path would A* graph search, using a consistent heuristic, return for this search problem? S-A-C-G",
        image:"/ai_17.png"
      },
      {
        text: "Perform A* search and Greedy best-first search on the given graph to find the shortest path from node a to node z. Each edge is labeled with the cost to traverse that edge. Heuristic values are given in the table below the graph.",
        
      },
      {
        text: "Differentiate greedy-best first search and A* search by solving the search path from node a to r in the following instance of the graph. The heuristic distance value is given near the nodes. Numbers written on the edges represent the distance between the nodes.",
        image:"/ai_18.png"
      },
      {
        text: "Apply greedy best first search on the following graph and find a path from the start mode (S) to the goal node (E).",
        image:"ai_19.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default InformedSearchMethods;
